import $ from 'jquery';

/* safe console */
export function log(msg) {
  if (window.console && msg) {
    window.console.log(msg);
  } else {
    throw new Error('Console Error');
  }
}
/* for each */
export function forEach(array, callback, scope) {
  for (let i = 0; i < array.length; i += 1) {
    callback.call(scope, i, array[i]);
  }
}
/* popup */
export function popup(e, href, intWidth = 500, intHeight = 400, blnResize = true) {
  if (e && href) {
    try {
      e.preventDefault();
    } catch (err) {
      throw new Error('e not defined');
    }
    const strResize = (blnResize ? 'yes' : 'no');
    const strParam = `width=${intWidth},height=${intHeight},resizable=${strResize}`;
    window.open(href, 'Social Share', strParam).focus();
    return true;
  }

  throw new Error('Invalid popup parameters');
}
/* brightcove */
export function getBrightcoveVideoData(videoID, callback) {
  const accountID = 75934411001;
  const policyKey = 'BCpkADawqM0NvUfP8kau23tpJMWdg09UoT0lqv-Aoqc98Q-ug4rTtp17hA99TA9yLT4-SJm-oIpkYExCvnGqb1fpbxMZM1Y8Yy1Hol4HdRpWGuJHGskT_7155ak';
  const path = `https://edge.api.brightcove.com/playback/v1/accounts/${accountID}/videos/${videoID}`;
  $.ajax({
    type: 'GET',
    url: path,
    cache: false,
    contentType: 'application/json',
    crossDomain: true,
    processData: true,
    headers: {
      Accept: `application/json;pk=${policyKey}`,
    },
    success(brightcoveVideoData) {
      callback(brightcoveVideoData);
    },
    error(xhr, status, errorThrown) {
      console.log(`${errorThrown}\n${status}\n${xhr.statusText}`);
    },
  });
}



// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/package/src/js/cmpUtils.js